import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
export default {
  name: 'Newsletter',
  data: function data() {
    return {
      email: '',
      background: ''
    };
  },
  computed: _objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  }), {
    urlPrefix: function urlPrefix() {
      return "".concat(this.locale.market, "/").concat(this.locale.language);
    }
  }),
  mounted: function mounted() {
    this.background = 'https://www.maisonsdumonde.com/mdm-static/common/img/footer/bg-newsletter.jpg';
    this.email = this.$route.params.email;
  },
  methods: {
    submitEmail: function submitEmail() {
      this.$router.push({
        name: 'market-language-editorial',
        params: {
          market: this.locale.market,
          language: this.locale.language,
          alias: 'newsletter',
          slug: 'inscription',
          email: this.email
        }
      });
    }
  }
};